import { TrackUsageParams, trackUsage } from '@/api/usage/usageTracker';
import { SourceApp } from '@/constants/usage';
import { useCallback } from 'react';

export const useTrackUsage = () => {
    const mutate = useCallback(
        async (
            params: Omit<TrackUsageParams, 'sourceApp'> & { token?: string }
        ) => {
            await trackUsage({
                ...params,
                sourceApp: SourceApp.CHAT_SERVER,
                token: params.token
            });
        },
        []
    );

    return { mutate };
};
